import { jsx as f } from "react/jsx-runtime";
import * as l from "react";
import { cva as u } from "class-variance-authority";
import { cn as x } from "../../lib/utils.mjs";
import { spaceMapping as t } from "../../spacing.mjs";
const g = u("", {
  variants: {
    variant: {
      default: "text-current",
      primary: "text-primary",
      secondary: "text-secondary",
      success: "text-success",
      danger: "text-danger",
      warning: "text-warning",
      white: "text-white"
    },
    disabled: {
      true: "text-neutral-70 pointer-events-none",
      false: ""
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), h = l.forwardRef(
  ({ icon: e, width: a, height: r, variant: n, inline: i = !1, className: s, disabled: o = !1, ...c }, d) => {
    const m = t[a ?? 5], p = t[r ?? 5];
    return /* @__PURE__ */ f(
      "span",
      {
        className: x(
          g({ variant: n, disabled: o }),
          i && "inline-block",
          `iconify ${e}`,
          s
        ),
        style: { width: m, height: p },
        ref: d,
        ...c
      }
    );
  }
);
h.displayName = "Icon";
export {
  h as default
};
//# sourceMappingURL=Icon.mjs.map
